import React from "react";
import SecondaryInputTable from "../../components/ui/InputTables/SecondaryInputTable";
import vectorGraphStorage from "../../images/graph-storage.svg";
import iconStorage from "../../images/icons/icon-storage-color.svg";
import iconStatsStorage1 from "../../images/icons/icon-stats-storage1.svg";
import iconStatsStorage2 from "../../images/icons/icon-stats-storage2.svg";
import iconStatsStorage3 from "../../images/icons/icon-stats-storage3.svg";
import iconStatsStorage4 from "../../images/icons/icon-stats-storage4.svg";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import Section from "../../components/ui/Section";
import ServiceAddedValueSection from "../../components/ui/PageSections/ServiceAddedValueSection";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";

const StoragePageTemplate = ({ pageContext, translations }) => {
	return (
		<div id="StorageInputSection">
			<PageHeroSection
				heroTitle={translations["StorageMainTitle"] ? translations["StorageMainTitle"] : pageContext.h1Title}
				heroIcon={iconStorage}
				heroIconAltText="White rombus rack icon"
				subtitle={translations["StorageTitle"] ? translations["StorageTitle"] : pageContext.h2Title}
				intro={translations["StorageIntro"]}
			/>
			<SecondaryInputTable
				serviceType="storage"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
				featureList={["Scalability", "Maximum Performance", "Certified Data Centers"]}
			/>
			<Section skewed="bottom">
				<div className="flex flex-col lg:flex-row lg:gap-8 justify-between md:items-end w-full">
					<div className="w-full lg:w-2/5">
						<div className="relative container">
							<ServiceAddedValueSection
								secondaryTitle={"StorageAddedValueSmallTitle"}
								title={"StorageAddedValueTitle"}
								serviceTabs={[
									{
										title: "StorageAddedValueTitleOne",
										content: "StorageAddedValueTextOne",
									},
									{
										title: "StorageAddedValueTitleTwo",
										content: "StorageAddedValueTextTwo",
									},
									{
										title: "StorageAddedValueTitleThree",
										content: "StorageAddedValueTextThree",
									},
									{
										title: "StorageAddedValueTitleFour",
										content: "StorageAddedValueTextFour",
									},
								]}
								translations={translations}
							/>
						</div>
						<div className="bg-gray-100 p-4 md:p-8 m-auto rounded-lg max-w-[600px] h-fit mt-16">
							<span className="border-2 cursor-default relative text-xs font-bold inline-flex items-start rounded-md py-0.5 px-2 z-0 border-black text-black">
								{translations["StorageStatsLabel"]}
							</span>
							<p className="my-8 text-sm text-ipxon-medium-dark-gray">
								{translations["StorageAddedValueText"]}
							</p>

							<ul className="grid grid-cols-2 w-full gap-8">
								{[
									{
										icon: iconStatsStorage1,
										title: "StorageStatOneTitle",
										text: "StorageStatOneText",
									},
									{
										icon: iconStatsStorage2,
										title: "StorageStatTwoTitle",
										text: "StorageStatTwoText",
									},
									{
										icon: iconStatsStorage3,
										title: "StorageStatThreeTitle",
										text: "StorageStatThreeText",
									},
									{
										icon: iconStatsStorage4,
										title: "StorageStatFourTitle",
										text: "StorageStatFourText",
									},
								].map((serviceStat) => (
									<li
										className="flex flex-col gap-2 text-sm text-ipxon-black"
										key={serviceStat.title}
									>
										<img
											src={serviceStat.icon}
											alt="Stats Icon"
											className="h-[30px] md:h-[30px] w-[30px]"
										/>
										<div className="flex flex-col">
											<h5 className="font-bold text-sm">{translations[serviceStat.title]}</h5>
											<p className="text-sm">{translations[serviceStat.text]}</p>
										</div>
									</li>
								))}
							</ul>
							{/* <div className="flex self-center mt-8">
								<PrimaryOutlineButton
									onClick={() => {
										navigate("#StorageInputSection");
									}}
								>
									{translations["StorageButtonText"]}
								</PrimaryOutlineButton>
							</div> */}
						</div>
					</div>
					<div className="relative flex flex-col gap-8 w-full max-w-[500px] m-auto lg:w-3/5">
						<img
							className="w-full px-[30px] lg:px-0 mt-16 lg:mt-0"
							src={vectorGraphStorage}
							alt="Graphic showing how IPXON storage works"
						/>
					</div>
				</div>
			</Section>
			<Section color="transparent">
				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section>
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["StorageContactUsBannerTitle"]}
					subtitle={translations["StorageContactUsBannerText"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default StoragePageTemplate;
